export default "__VITE_ASSET__74f98345__"